import axios from '../axios';

const transactionsAPI = {
  getAll: async (params) => {
    const response = await axios.get('/transactions', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/transactions/${id}`);
    return response.data;
  },

  // create: async (transactionData) => {
  //   const response = await axios.post('/transactions', transactionData);
  //   return response.data;
  // },

  create: async (transactionData) => {
    // Server returns JSON: { success, created, skipped, file (base64 MASAV content) }
    const response = await axios.post('/transactions', transactionData);
    return response.data;
  },

  exportMasav: async ({ asc_nums, charge_date, use_extern_number }) => {
    const response = await axios.post(
      '/transactions/export-masav',
      { asc_nums, charge_date, use_extern_number },
      { responseType: 'blob' }
    );
    return response.data;
  },

  markExported: async ({ asc_nums }) => {
    const response = await axios.post('/transactions/mark-exported', { asc_nums });
    return response.data;
  },

  update: async (id, transactionData) => {
    const response = await axios.put(`/transactions/${id}`, transactionData);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/transactions/${id}`);
    return response.data;
  },

  getByCustomer: async (customerId) => {
    const response = await axios.get(`/transactions/customer/${customerId}`);
    return response.data;
  },

  getByInstitution: async (mosadId) => {
    const response = await axios.get(`/transactions/mosad/${mosadId}`);
    return response.data;
  },

  getByBank: async (bankId) => {
    const response = await axios.get(`/transactions/bank/${bankId}`);
    return response.data;
  }
};

export default transactionsAPI; 